import { CoordinatesType } from '@api';
import { faMap } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Anchor, Divider, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'GENERAL_INFORMATION.COORDINATES';

type CoordinatesPropsType = {
  coordinates: CoordinatesType;
};

export const Coordinates: React.FC<CoordinatesPropsType> = ({
  coordinates,
}) => {
  const { t } = useTranslation('venueDetailsGeneral');

  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${coordinates.latitude},${coordinates.longitude}`;

  return (
    <Group>
      <Text>
        {t(`${TRANS_KEY}.LATITUDE`)}: {coordinates.latitude}
      </Text>
      <Divider orientation="vertical" />
      <Text>
        {t(`${TRANS_KEY}.LONGITUDE`)}: {coordinates.longitude}
      </Text>
      <Anchor c="blue" href={googleMapsUrl} target="_blank">
        <FontAwesomeIcon icon={faMap} />
      </Anchor>
    </Group>
  );
};
